/**
 * Preprocesses markdown text to convert bullet characters (•) to proper markdown list syntax
 */
export function preprocessBullets(markdown: string): string {
  // Early return optimization
  if (!markdown.includes('•')) {
    return markdown;
  }

  // Fast path for single-line content (most common case)
  if (!markdown.includes('\n')) {
    const trimmed = markdown.trim();
    if (trimmed.startsWith('•')) {
      return `- ${trimmed.substring(1).trim()}`;
    }
    return markdown;
  }

  // Multi-line processing - use efficient array operations
  const lines = markdown.split('\n');
  const processedLines: string[] = [];
  let inBulletList = false;

  for (const line of lines) {
    const trimmedLine = line.trim();
    const isBulletLine = trimmedLine.startsWith('•');

    if (isBulletLine) {
      // Convert bullet character to markdown list syntax
      const bulletContent = trimmedLine.substring(1).trim();
      processedLines.push(`- ${bulletContent}`);
      inBulletList = true;
    } else {
      // Handle spacing after bullet lists
      if (inBulletList && trimmedLine !== '') {
        inBulletList = false;
      }
      processedLines.push(line);
    }
  }

  return processedLines.join('\n');
}
